import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null
  };

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    const { children, fallback: Fallback } = this.props;
    const { error, errorInfo } = this.state;
    if (errorInfo) {
      // Error path
      if (Fallback) {
        return <Fallback errorInfo={errorInfo} error={error} />;
      }
      if (process.env.NODE_ENV === 'development') {
        return (
          <div>
            <h2>Something went wrong.</h2>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {error && error.toString()}
              <br />
              {errorInfo.componentStack}
            </details>
          </div>
        );
      }
      return null;
    }

    // Normally, just render children
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  fallback: PropTypes.elementType
};

ErrorBoundary.defaultProps = {
  children: null,
  fallback: undefined
};

ErrorBoundary.componentName = 'ErrorBoundary';

export default ErrorBoundary;
